import {segment} from './helpers'
import {clickedLink} from './other'

export const addItemClicked = () => {
  segment('Add Item', {target: 'Add Item Category List', text: 'Add Item'})
}

export const addItemErrorClicked = () => {
  segment('Add Item Error', {target: 'Less than 3 days error modal'})
}

export const addAnotherItemClicked = () => {
  segment('Add Another Item', {target: 'Your Cart Page', text: 'Add Another Item'})
}

export const productCategoryClicked = (name, url) => {
  segment(`${name}`, {target: url})
}

export const shippingAddressEditClicked = (url) => {
  segment('Shipping Address Edit', {location: url, target: url, text: 'Edit'})
}

export const viewedCart = (url) => {
  segment('Viewed Cart', {location: url, target: url, text: 'Cart'})
}

export const viewedPaymentReview = () => {
  segment('Viewed Payment Review', {text: 'Payment Review'})
}

export const viewedRentalReview = () => {
  segment('Viewed Rental Review', {text: 'Rental Review'})
}

export const viewedShippingAddress = (url) => {
  segment('Viewed Checkout', {location: url, target: url, text: 'Checkout'})
}

export const viewedThankYou = () => {
  segment('Viewed Thank You', {text: 'Thank You'})
}

export const clickedRemoveItemsButton = () => {
  clickedLink({
    location: 'Order Manger Page',
    target: 'Add Item Category List',
    type: 'link',
    text: 'Remove Item',
  })
}

export const viewedRemoveItemsPage = () => {
  segment('Viewed Remove Items Page')
}

export const clickedRemoveItemsSubmit = (refundsList, isCancelingOrder) => {
  segment('Clicked Remove Items Submit', {refundsList, isCancelingOrder})
}

export const clickedRemoveItemsDoubleConfirmSubmit = () => {
  clickedLink({location: 'Remove Items Page', type: 'button'})
}

export const viewedRemoveItemsCustomerCareModal = () => {
  segment('Viewed Remove Items Zendesk Modal')
}

export const viewedRemoveItemsSuccessModal = () => {
  segment('Viewed Remove Items Success Modal')
}

export const viewedRemoveItemsErrorModal = () => {
  segment('Viewed Remove Items Contact CC Error Modal')
}
